export * from './saga-guards'

export const TO_INTRO_S0 = '/'
export const TO_INTRO_S1 = '/step-1'
export const TO_INTRO_S2_OLD = '/step-2-old'
export const TO_INTRO_S2 = '/step-2'
export const TO_TRADI_S1 = '/tradizionale/step-1'
export const TO_TRADI_S2 = '/tradizionale/step-2'
export const TO_TRADI_S3 = '/tradizionale/step-3'
export const TO_TRADI_S4 = '/tradizionale/step-4'
export const TO_TRADI_S5 = '/tradizionale/step-5'
export const TO_FASTQ_S1 = '/fast-quote/step-1'
export const TO_GENER_S1 = '/generazione/step-1'
export const TO_GENER_S2 = '/generazione/step-2'
export const TO_GENER_S3 = '/generazione/step-3'
export const TO_GENER_S4 = '/generazione/step-4'
export const TO_COOKIE_POLICY_LIST = '/cookie-policy'
export const TO_ACCESSIBILITY = '/accessibilita'
export const TO_ERROR_404 = '/error-404'
export const TO_ERROR_500 = '/error-500'
